const PriorityConstants = {
  Critical: '01_Emergency',
  Medium: '03_Routine',
  High: '02_Urgent',
};

export default PriorityConstants;
